import styled from "styled-components";

import { ArrowLeftIcon } from "./ArrowLeft";

export const ArrowRightIcon = styled(ArrowLeftIcon)`
  transform: scaleX(-1);
`;
